import State from './state';

export function error(state) {
  return state.error;
}

export function errorMessage(state) {
  return state.errorMessage;
}

export function getIsCharging(state) {
  return state.charging;
}

export function getAboutUs(state) {
  return state.about;
}

export function getChildStars(state) {
  return (id) => {
    return state.childStars[id];
  };
}

export function getCriterionDescription(state) {
  return state.CriterionDescription;
}

export function getAvatarImages(state) {
  return state.avatarImages;
}

export function getFaqsPosts(state = State) {
  return state.faq.posts;
}

export function getFaqsTopics(state = State) {
  return state.faq.topics;
}
